import { useCallback } from 'react';
import type { HeadlineSmallOneLineProps } from './types';
import { Headline, HeadlineRightPanel } from '@banhala/ui-kit';
import { bridge, isNil } from '../../../../utils';
import type { IScreensLogging } from '../../../../api/types';
import { ViewAllButton } from '../ViewAllButton';

export const HeadlineSmallOneLine = ({ header }: HeadlineSmallOneLineProps) => {
  const handleClickViewAllButton = useCallback(() => {
    if (isNil(header)) return;
    const { deeplink } = header.item;
    if (isNil(deeplink)) return;

    logClickViewAllButton({ logging: header.logging });

    bridge.openDeeplink(deeplink);
  }, [header]);

  if (isNil(header)) {
    return null;
  }
  const isRoutable = header.item.deeplink !== null;

  return (
    <>
      <Headline
        size="medium"
        headline={header.item.title}
        testID={header.item.title}
        rightPanel={
          <>
            {isRoutable && (
              <HeadlineRightPanel type={'textButton'}>
                <ViewAllButton
                  onPress={handleClickViewAllButton}
                  padding={{ right: 4 }}
                />
              </HeadlineRightPanel>
            )}
          </>
        }
      />
    </>
  );
};

const logClickViewAllButton = ({ logging }: { logging: IScreensLogging }) => {
  bridge.logAnalyticsEvent({
    name: 'CLICK_HEADLINE_SMALL_ONE_LINE_MORE',
    analytics: logging.analytics,
    ably_only_log: logging.ably_only_log,
  });
};
